/* @flow */

import React, { useContext } from "react";
import cn from "classnames";

import Button from "components/Button";
import { StoreInfoContext } from "entrypoint/shared";

import styles from "./styles.scss";

type Props = {
  secondary?: boolean,
};

const ContentBox = ({ secondary = false }: Props): React$Node | null => {
  const { content: { homeview } } = useContext(StoreInfoContext);
  const status = secondary ?
    homeview.heroSecondaryInfoFieldStatus :
    homeview.heroPrimaryInfoFieldStatus;
  const text = secondary ?
    homeview.heroSecondaryInfoFieldText :
    homeview.heroPrimaryInfoFieldText;
  const heading = secondary ?
    homeview.heroSecondaryInfoFieldHeading :
    homeview.heroPrimaryInfoFieldHeading;
  const image = secondary ?
    homeview.heroSecondaryInfoFieldImage :
    homeview.heroPrimaryInfoFieldImage;
  const link = secondary ?
    homeview.heroSecondaryInfoFieldLink :
    homeview.heroPrimaryInfoFieldLink;
  const linkText = secondary ?
    homeview.heroSecondaryInfoFieldLinkText :
    homeview.heroPrimaryInfoFieldLinkText;

  if (status !== true) {
    return null;
  }

  return (
    <div
      className={cn(
        styles.contentBox,
        "awardit-heroContentBox",
        secondary ?
          "awardit-heroContentBox-secondary" :
          "awardit-heroContentBox-primary"
      )}
    >
      {image &&
        <div className={styles.contentBoxImageWrapper}>
          <img src={image} />
        </div>
      }
      {(heading || text) && (
        <div className={styles.contentBoxContent}>
          {heading && (
            <h2 className={styles.contentBoxHeader}>{heading}</h2>
          )}
          {text && (
            /* eslint-disable react/no-danger */
            <div
              dangerouslySetInnerHTML={{ __html: text }}
              className={cn(styles.contentBoxDescription, "awardit-heroContentBoxDescription")}
            />
            /* eslint-enable react/no-danger */
          )}
          {(link && linkText) && (
            <Button
              to={link}
              variant="primary"
              size="small"
              className={cn(styles.contentBoxButton, "awardit-heroContentBoxButton")}
            >
              {linkText}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default ContentBox;
